import { render, staticRenderFns } from "./PointPack.vue?vue&type=template&id=3531457e&scoped=true"
import script from "./PointPack.vue?vue&type=script&lang=js"
export * from "./PointPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3531457e",
  null
  
)

export default component.exports